// src/services/admin.ts

export type TokenStatus = {
  hasAccessToken: boolean;
  accessTokenExpiresAt?: string;
  lastUpdatedAt?: string;
};

export async function adminGetTokenStatus(): Promise<TokenStatus> {
  const resp = await fetch('/api/hq-admin-api/token-status', {
    method: 'GET',
    cache: 'no-store',
    credentials: 'include',
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`Token status failed (HTTP ${resp.status}). ${text}`);
  }

  return (await resp.json()) as TokenStatus;
}

// NEW: Force refresh (server-side)
export async function adminRefresh(): Promise<TokenStatus> {
  const resp = await fetch('/api/hq-admin-api/refresh', {
    method: 'POST',
    cache: 'no-store',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({}), // keep body non-empty for some gateways
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`Force refresh failed (HTTP ${resp.status}). ${text}`);
  }

  return (await resp.json()) as TokenStatus;
}

// NEW: OAuth authorize must be popup/window navigation (not fetch)
export function openCchAuthorizePopup() {
  const url =
    (window as any).__CCH_AUTHORIZE_URL__ ||
    'https://js-function-bmss.azurewebsites.net/api/authorizeCCH';

  const w = 720;
  const h = 900;
  const left = Math.max(0, Math.floor(window.screenX + (window.outerWidth - w) / 2));
  const top = Math.max(0, Math.floor(window.screenY + (window.outerHeight - h) / 2));

  const popup = window.open(
    url,
    'cch_oauth',
    `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes`
  );

  if (!popup) window.location.href = url;

  return popup;
}
